interface ITileSetSizeMetadata {
  z: number;
  size: number[] | number;
}

export interface ITileSetMetadata {
  sizes?: ITileSetSizeMetadata[];
  lowg?: {c: string, z: number[]}[];
}

export enum TsRenderType {
  POI = "poi",
  POS = "pos",
  SURF = "surf",
  LABEL = "label"
}

class TileSet {
  public id: number = null;
  public uuid: string = null;
  public name: string = null;
  public description: string = null;
  public createdAt: Date = null;
  public updatedAt: Date = null;
  public geoColumnId: string = null;
  public geoColumnCode: string = null;
  public nameColumn: string = null;
  public geomType: string = null;
  public computed: boolean = false;
  public region: string = null;
  public version: string = null;
  public minZoom: number = null;
  public maxZoom: number = null;
  public upColumnCode: string = null;
  public downColumnCode: string = null;
  public metadata: ITileSetMetadata = {};
  public isInternal: boolean = false;
  public isCustom: boolean = false;
  public extent: object = {};
  public multipartExtent: object = null;
  public renderType: TsRenderType = null;
  public isLive: boolean = null;
  public qi: string = null;
  public qualifiedTableName: string = null;
  public label: string = null;

  static fromPayload(payload: any) {
    !payload && (payload = {});
    const o = new TileSet();

    try {
      Object.assign(o, payload);
    } catch(err) {
      console.error(err)
    }

    return o;
  }
}

export { TileSet }
